import type { SortingStrategy } from '@dnd-kit/sortable';
import { move } from 'ramda';

export const strategy: SortingStrategy = (ref) => {
  const { rects, activeIndex: draggedIndex, overIndex, index } = ref;

  const currentRect = rects[index];
  const positionedRects = move(overIndex, draggedIndex, rects);
  const positionedRect = positionedRects[index];

  if (!positionedRect || !currentRect) return null;

  const x = positionedRect.left - currentRect.left;
  const y = positionedRect.top - currentRect.top;

  return { x, y, scaleX: 1, scaleY: 1 };
};
